module.exports = __webpack_public_path__ + "img/IMG_1699_Wood_MockedUp.4cbfefb9.jpg";